import { BoletoIcon, CreditCardIcon, PixIcon } from 'clubbi-ui'
import {
  StyledIconlessContainer,
  StyledInstallmentsToggleButton,
  StyledInstallmentsToggleButtonGroup,
  StyledSubLabel,
  StyledToggleButton,
  StyledToggleButtonGroup,
} from './styles/ToggleButtonGroup.style'

import { ClubbiToggleButtonGroupProps } from './interfaces'
import { setCurrency } from '../../../common/cardUtils'

const getIcon = (value: any) => {
  switch (value) {
    case 0:
      return <BoletoIcon />
    case 1:
      return <CreditCardIcon />
    case 2:
      return <PixIcon />

    default:
      break
  }
}

export const ClubbiToggleButtonGroup = ({
  id,
  hasIcon,
  value,
  paymentLabels,
  onChange,
}: ClubbiToggleButtonGroupProps) => {
  return (
    <StyledToggleButtonGroup exclusive value={value} id={id} onChange={onChange} fullWidth>
      {paymentLabels.map(({ id: itemId, label, subLabel }) => (
        <StyledToggleButton
          isFiscal={id === 'invoiceType'}
          id={`${id}-${itemId}`}
          value={itemId}
          key={`${id}-${itemId}`}
        >
          {hasIcon ? (
            <>
              <span className="payment-icon">{getIcon(itemId)}</span>
              <span>{label}</span>
            </>
          ) : (
            <StyledIconlessContainer>
              <span>{label}</span>
              {subLabel && <StyledSubLabel>{subLabel}</StyledSubLabel>}
            </StyledIconlessContainer>
          )}
        </StyledToggleButton>
      ))}
    </StyledToggleButtonGroup>
  )
}

type InstallmentOption = {
  installment: number
  days: string | undefined
}

interface InstallmentsToggleButtonGroupProps {
  value: any
  installmentOptions: InstallmentOption[]
  totalValue: number
  isInstantPayment: boolean | undefined
  onChange: (event: React.MouseEvent<HTMLElement, MouseEvent>, value: any) => void
}

export const InstallmentsToggleButtonGroup = ({
  value,
  installmentOptions,
  totalValue,
  isInstantPayment,
  onChange,
}: InstallmentsToggleButtonGroupProps) => {
  return (
    <StyledInstallmentsToggleButtonGroup exclusive value={value} onChange={onChange} fullWidth>
      {installmentOptions.map((installment, index) => {
        const formattedValue = setCurrency(totalValue / installment.installment)

        const label = isInstantPayment
          ? `${installment.installment}x R$${formattedValue} (À vista durante a entrega)`
          : `${installment.installment}x R$${formattedValue} (${installment.days} dias)${
              index > 0 ? ' sem acréscimo' : ''
            }`

        return (
          <StyledInstallmentsToggleButton
            key={installment.installment}
            value={installment.installment}
          >
            <div>
              <span>{label}</span>
            </div>
          </StyledInstallmentsToggleButton>
        )
      })}
    </StyledInstallmentsToggleButtonGroup>
  )
}
